export default __webpack_public_path__ + "static/expo4-0a5537936ccaf552eab7765b16a64521.jpg";